import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=36a25bba&"
import script from "@/views/Login/Login.js?vue&type=script&lang=js&"
export * from "@/views/Login/Login.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports